import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

interface ValidationRequest {
  vehicleId: string
  clientId: string
}

interface ValidationResponse {
  hasDuplicate: boolean
  existingDeal?: {
    _id: string
    createdAt: string
    contactedVia: string
    vehicle: {
      brand: string
      model: string
      plate: string
    }
    client: {
      firstname: string
      lastname: string
    }
  } | null
}

export const useDealValidation = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const validateDeal = async (vehicleId: string, clientId: string): Promise<ValidationResponse> => {
    setLoading(true)
    setError(null)

    try {
      const apiUrl = '/api/deal_validate'
      const apiParams: ValidationRequest = { vehicleId, clientId }

      const response = await customPost<ValidationResponse>(apiUrl, apiParams)

      return response
    } catch (err) {
      const validationError = err instanceof Error ? err : new Error('Validation failed')
      setError(validationError)
      throw validationError
    } finally {
      setLoading(false)
    }
  }

  return {
    validateDeal,
    loading,
    error,
  }
}
